<div class="my-5">
    <sm-page-header [breadcrumb]="breadcrumb"
        [title]=" isInspectMode() ?'settings.committee.consult.title': 'settings.committee.update.title'"
        ></sm-page-header>
    <div class="content">
        <sm-form-builder [formObject]="formObject" class="w-full px-4" (formValueChange)="onFormChange()"></sm-form-builder>
        <div *ngIf="!isInspectMode()" class="flex justify-end gap-2">
            <p-button [label]="'settings.committee.update.update' | translate"  [disabled]="(isFormValid$ | async) === false" (click)="updateCommittee()" />
            <p-button [label]="'settings.committee.update.cancel' | translate" severity="secondary" (click)="onCancel()" />
        </div>
        <p-tabs [(value)]="selectedTab" (valueChange)="onTabChange($event)" scrollable class="mt-4 bg-transparent">
            <p-tablist>
                <p-tab value="members">{{ 'settings.committee.tabs.memebers' | translate }}</p-tab>
                <p-tab value="acs" *ngIf="isAcsComsVisible">{{ 'settings.committee.tabs.acs' | translate }}</p-tab>
                <p-tab value="conselliers">{{ 'settings.committee.tabs.conselliers' | translate }}</p-tab>
            </p-tablist>
            <p-tabpanels>
                <p-tabpanel value="members">
                    <sm-members [committeeId]="committeeRepository.getNested('response', 'id')"
                        [members]="(users$ | async) || []"
                        [isInspectMode]="isInspectMode()"></sm-members>
                </p-tabpanel>
                <p-tabpanel value="acs">
                    <sm-acs-coms [committeeId]="committeeRepository.getNested('response', 'id')"
                        [acs]="committeeRepository.getNested('response', 'acs')"
                        [isInspectMode]="isInspectMode()"></sm-acs-coms>
                </p-tabpanel>
                <p-tabpanel value="conselliers">
                    <sm-members [committeeId]="committeeRepository.getNested('response', 'id')"
                        [members]="(conselliers$ | async) || []"
                        [isInspectMode]="isInspectMode()" [isConsellierMode]="true"></sm-members>
                </p-tabpanel>
            </p-tabpanels>
        </p-tabs>
    </div>
</div>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
